import { Locale, type LocalizedString } from "@core/schema/Locale.js";

export const clientSearchParamLocalized: LocalizedString = {
	[Locale.cs]: "klient",
};
